import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Spin } from 'antd';
import { getNotifications, markAsRead } from '../api/notifications';
import { notificationTarget } from '../utils/notificationTarget';
import useAuthStore from '../store/authStore';

/**
 * Web push bildirimine tıklandığında açılan ara sayfa: /bildirim/:id
 *
 * NEDEN ARA SAYFA VAR — service worker doğrudan hedefe gönderemez mi?
 * Gönderemez, çünkü hangi bildirimin nereye gideceği ROL BAZLI ve kural
 * `utils/notificationTarget.js` içinde. Service worker ayrı bir bağlamda
 * çalışıyor, uygulamanın modüllerini ve oturumdaki rolü göremiyor.
 *
 * Tabloyu service worker'a kopyalamak ilk akla gelen çözümdü ve bilerek
 * yapılmadı: yeni bir bildirim türü eklendiğinde iki yerin birden
 * güncellenmesi gerekirdi ve bu projede tam olarak o desen defalarca
 * saptı (bkz. CLAUDE.md — bildirim hedefleri web/mobil ayrımı). Burada
 * SW yalnızca id taşıyor, karar tek yerde kalıyor.
 *
 * Bildirim ayrıca OKUNDU işaretleniyor — kullanıcı zaten tıklayıp açtı,
 * zil ikonunda okunmamış görünmeye devam etmesi yanlış olurdu.
 */
const NotificationRedirect = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuthStore();

  useEffect(() => {
    let iptal = false;

    const gonder = async () => {
      const anaSayfa = user?.role === 'parent' ? '/parent/dashboard' : '/dashboard';

      try {
        // Tek bildirim için ayrı bir uç yok; push'a konu olan bildirim
        // tanımı gereği yeni olduğu için ilk sayfada bulunuyor.
        const { data } = await getNotifications({ per_page: 50 });
        const liste = data?.data || data || [];
        const bildirim = liste.find((n) => String(n.id) === String(id));

        if (iptal) return;

        if (!bildirim) {
          navigate(anaSayfa, { replace: true });
          return;
        }

        markAsRead(bildirim.id).catch(() => {});

        const hedef = notificationTarget(bildirim, user?.role);
        navigate(hedef || anaSayfa, { replace: true });
      } catch {
        if (!iptal) navigate(anaSayfa, { replace: true });
      }
    };

    gonder();
    return () => { iptal = true; };
  }, [id, navigate, user]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Spin size="large" tip="Bildirim açılıyor..." />
    </div>
  );
};

export default NotificationRedirect;
